import { COCKPIT_GAP } from '../../common/cockpitBubble/constants';

export const PLAYBACK_DEFAULT_WRAPPER_STYLE = {
  default: {
    display: 'flex'
  },
  '!small': {
    gap: COCKPIT_GAP
  }
};

export const PLAYBACK_CENTERED_WRAPPER_STYLE = {
  opacity: 1,
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
  alignItems: 'center',
  width: '100%',
  transition: 'opacity .3s ease-in-out',
  gap: COCKPIT_GAP
};

export const PLAYBACK_HIDDEN = {
  opacity: 0,
  pointerEvents: 'none'
};
